import { EmailRegexp } from '@rehau/shared/regexps';
import { StringValidation } from '@rehau/shared/forms/validations';
import { ErrorMessageEnum } from '@rehau/shared/enums';

export class EmailValidation extends StringValidation {
  constructor() {
    super(undefined, undefined, [{ pattern: EmailRegexp, message: ErrorMessageEnum.email_wrong_format }]);
  }
}
